export interface IAppProps {
  userType?: string;
}

export enum UserType {
  Public = 'public',
  Operator = 'operator',
}

export enum UserData {
  Subscriber = 'Subscriber',
  NeedsVerification = 'NeedsVerification',
}
